module.exports = __webpack_public_path__ + "img/page-16.f5455a6c.jpg";